import React, { useState, useContext } from "react";
import RemoveIcon from "../RemoveIcon/RemoveIcon";
import EditIcon from "../EditIcon/EditIcon";
import AddCommand from "../AddCommand/AddCommand";
import SelectedRowIcon from "../SelectedRowIcon/SelectedRowIcon";
import ToolComponent from "../../ToolComponent/ToolComponent";
import "../../Styles/globalStyle.css";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Rows(props) {
  const buildStyle = useBuildStyle();

  const [currentRow, setCurrentRow] = useState({
    id: props.data.id
  });
  
  const getVisibleColumn = () => {
    
    var visiblesColumns = JSON.parse(JSON.stringify(props.data.metaData.filter((item) =>
      props.data.selectedValues.includes(item.headerId) 
    ))) ;
    
    
    visiblesColumns.map(column => {
      column.styles["resize"] = {value:"none"};
      /*if (props.isHeader == false){
        delete column.styles.resize; 
        delete column.styles.overflow; 
      } */
    })
    
    return visiblesColumns;
  };

  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    const border =  props.draggable && props.isSelected
    ? "1px dashed gray"
    : props.style.border.value
    
    newStyle["border"] = undefined
    newStyle["borderTop"] = "none";
    newStyle["borderLeft"] = "none";
    newStyle["borderRight"] = "none";
    newStyle["borderBottom"] = border;
    if (!props.draggable) newStyle["resize"] = "none"
    return newStyle;
  };

  const onClickRow = (e, template) => {
    props.onClick(e, template)
  };


  return (
    <div key={props.data.id} style={getStyle()} >
      <div className="selectLineCol" onClick={(e) => props.onClick(e, props.data)}>
        <div
          className="colGrid"
          style={{
            borderRight: "1px solid " + props.data.styles.color.value,
            width: "30px",
            paddingTop: "9px",
          }}
        >{props.data.isCurrentRow && <SelectedRowIcon />}</div>
      </div>
      <div className="controlGrid">
        {getVisibleColumn().map((template) => ( 
          <div
            className="colGrid"
            style={{ borderRight: "1px solid " + props.data.styles.color.value }}
            key={template.id}>
            <ToolComponent
              position="relative"
              meta={template}
              onlyLabel={false}
              dataGridColumn={true}
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e) => props.onBlur(e, template)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  {return}}
              //onMultiselectionClick={(itemSelected) => {return}}
              //onDropColumn={(e, column) => {return}}
              //onMouseOver={(e) => props.onMouseOver(e, template)}
              onMouseEnter={(e) => props.onMouseEnter(e, template)}
              onMouseDown={(e) => props.onMouseDown(e, template)}
              onMouseLeave={(e) => props.onMouseLeave(e, template)}
              onClick={(e) => onClickRow(e, template)}
            />
          </div>
        ))}
      </div>
      
      <div className="buttonGrid">
     
          
          <div style={{ display: "flex" }} >
              
            {props.add && <div style={{ marginRight: "2px" }} onClick={(e) => props.onClickAdd(e, props.data.index)}>
              <AddCommand />
            </div>}
            {props.delete && <div className="iconColGrid">
              <RemoveIcon onClick={(e) => props.onClickRemove(e, props.data.id)} />
            </div>}
          
        </div>
      </div>
    </div>
  );
}
